import {ReactNode} from 'react';

export interface CarouselOptions {
  isAutoPlay?: boolean;
  autoInterval?: number;
  slideSpeed?: number;
  isInfinite?: boolean;
  isSupportMouseEvent?: boolean;
  /**
   * centerMode일 때 처음 시작에 왼쪽에 붙어있는 모드
   * FIXME : 디자인쪽 요구에 의해 왼쪽에 붙어있는 모드를 만들었습니다. margin이나 gap으로 어떻게 해보려했는데 transition과 얽혀있어 쉽지 않더라구요...더 나은 방식이 있다면 고쳐주세요!
   */
  isLeftSideMode?: boolean;
  /**
   * item을 swipe로 넘기기 위해 움직여야 하는 최소 px
   */
  minPxToSwipeItem?: number;
  isCenterMode?: boolean;
  /**
   * Px, %등 unit이 붙은 수치 (ex. 50px, 50%)
   * centermode true시에만 유효함
   */
  centerPadding?: string;
  renderDots?: (currentIndex: number, dotCount: number) => ReactNode;
  renderNextArrow?: (goToNext: () => void) => ReactNode;
  renderPrevArrow?: (goToPrev: () => void) => ReactNode;
  /**
   * 현재 index가 변경되었을 떄 발생. 애니메이션과는 관계 없이 index 변경시 바로 발생한다
   */
  onChangeIndex?: (currentIndex: number) => void;
  gapPx?: number;
}

export const LEFT_SIDE_GAP_PX = 9;
